import { useMutation, useQueryClient } from '@tanstack/react-query'
import { aiStudioService } from '../../../service/aiStudio'

export const useFreeVideoSynthesis = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: ['free-video-synthesis'],
    mutationFn: aiStudioService.generateFreeVideoSynthesis,
    onSuccess: () => {
      // 비디오 리스트 새로고침
      queryClient.invalidateQueries({ queryKey: ['ai-studio', 'free-synthesis'] })
      // 상태 폴링 쿼리들도 invalidate
      queryClient.invalidateQueries({ queryKey: ['ai-studio', 'free-synthesis-status'] })
    },
  })
}